/* eslint-disable react-refresh/only-export-components */
import { HostContext } from "@buzzeasy/shared-frontend-utilities";
import React, { PropsWithChildren, ReactElement, useContext } from "react";
import useTranscriptHub, { TranscriptHub } from "../../hooks/useTranscriptHub";
import { CallTranslatorMode } from "../../model/hubDtos";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const TranscriptHubContext = React.createContext<TranscriptHub>(undefined!);

export interface TranscriptHubProviderProps {
  conversationId: string;
  mode: CallTranslatorMode;
}

export default function TranscriptHubProvider({ children, conversationId, mode }: PropsWithChildren<TranscriptHubProviderProps>): ReactElement {
  const { messageApi } = useContext(HostContext);

  const transcriptHub = useTranscriptHub(conversationId, messageApi, mode);

  return (
    <TranscriptHubContext.Provider value={transcriptHub}>
      {children}
    </TranscriptHubContext.Provider>
  );
}
